import React from 'react'
import deniewImg from "../../assets/images/access_denied.jpg"
import { Link } from 'react-router-dom'
import { app_url } from 'app_config'

const PermittedComponent = ({ children, isAccess = false }) => {

    return (
        <>
            {
                isAccess ?
                    children :
                    <div className='text-center py-5 bg-white rounded'>
                        <div>
                            <img src={deniewImg} alt="" height={350} />
                        </div>
                        <div>
                            <Link to={`${app_url}`} className="btn btn-primary px-5 py-3 fs-5 bg-blue ">
                                Go to Dashboard
                            </Link>
                        </div>
                    </div>
            }
        </>
    )
}

export default PermittedComponent